/**
 * Auth Configuration
 * Single source of truth for auth provider selection
 */

// Feature flag: true = Emergent Auth, false = Supabase Auth
export const USE_EMERGENT_AUTH = process.env.REACT_APP_USE_EMERGENT_AUTH === 'true';

// Supabase configuration
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// API URL
export const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Auth callback path
export const AUTH_CALLBACK_PATH = '/auth/callback';

// Check if Supabase is configured
export const isSupabaseConfigured = () => !!(SUPABASE_URL && SUPABASE_ANON_KEY);
